import { Box, type BoxProps } from "@mui/material"

import type { FC } from ".."

export interface ImageProps extends BoxProps<"img"> {
  src: string
  alt: string
}

const Image: FC<ImageProps> = ({ src, alt, ...props }) => {
  return (
    <Box component="img" src={src} alt={alt} data-chromatic="ignore" loading="lazy" {...props} />
  )
}
export default Image
